import { screenBreakpoints } from 'constants/sizes'

export const getNavMenuIconColor = (pathname, iconPathname, isFooter) =>
  pathname.startsWith(iconPathname) ? '#FF9D0E' : isFooter ? '#00007A' : '#fff'

export const isMobile = () => window.innerWidth < screenBreakpoints.sm
